import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import LoginPage from '../modules/auth/LoginPage'
import MedicinesList from '../pages/medicines/MedicinesList'
import AddNewMedicine from '../pages/medicines/AddNewMedicine'
import MedicineBuyingPrice from '../pages/medicines/MedicineBuyingPrice'
import ProtectedRoute from '../modules/shared/ProtectedRoute'
import BulkUploadMedicine from '../pages/medicines/BulkUpload'
import BillingList from '../pages/billing/BillingList'
import AddBilling from '../pages/billing/AddOrEditBill'
import PrintBill from '../pages/billing/PrintBill'
import AddEmployee from '../pages/employee/AddEmployee'
import EmployeesList from '../pages/employee/EmployeesList'
import EmployeeAttendance from '../pages/employee/EmployeeAttendance'
import EmployeeShifts from '../pages/employee/EmployeeShifts'
import EmployeeLeaves from '../pages/employee/EmployeeLeaves'
import ContactList from '../pages/contact/ContactList'
import AddEditContact from '../pages/contact/AddEditContact'
import Dashboard from '../pages/dashboard/Dashboard'
import PatientIntake from '../pages/patient/PatientIntake'
import PatientHistory from '../pages/patient/PatientHistory'
import IncomeReport from '../pages/reports/IncomeReport'
import StockReport from '../pages/reports/StockReport'
import ClinicalSuggestionsConfig from '../pages/configuration/ClinicalSuggestionsConfig'
import MedicineMinimumStockConfig from '../pages/configuration/MedicineMinimumStockConfig'
import { useAuth } from '../modules/auth/authContext'

const HomeRedirect: React.FC = () => {
  const { can } = useAuth()
  if (can('dashboard.view')) return <Navigate to="/dashboard" replace />
  if (can('patients.intake.view')) return <Navigate to="/patients/intake" replace />
  if (can('billing.view')) return <Navigate to="/billing" replace />
  if (can('catalog.view')) return <Navigate to="/medicines" replace />
  return <Navigate to="/login" replace />
}

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<ProtectedRoute><HomeRedirect /></ProtectedRoute>} />
      <Route path="/login" element={<LoginPage />} />

      <Route
        path="/dashboard"
        element={
          <ProtectedRoute permission="dashboard.view">
            <Dashboard />
          </ProtectedRoute>
        }
      />

      <Route path="/patients" element={<Navigate to="/patients/intake" replace />} />
      <Route
        path="/patients/intake"
        element={
          <ProtectedRoute permission="patients.intake.view">
            <PatientIntake />
          </ProtectedRoute>
        }
      />
      <Route
        path="/patients/history"
        element={
          <ProtectedRoute permission="patients.history.view">
            <PatientHistory />
          </ProtectedRoute>
        }
      />

      <Route
        path="/medicines"
        element={
          <ProtectedRoute permission="catalog.view">
            <MedicinesList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/medicines/new"
        element={
          <ProtectedRoute permission="catalog.view">
            <AddNewMedicine />
          </ProtectedRoute>
        }
      />

      <Route
        path="/medicines/bulk" element={
          <ProtectedRoute permission="catalog.edit">
            <BulkUploadMedicine />
          </ProtectedRoute>
        }
      />
      <Route
        path="/medicines/buying-price"
        element={
          <ProtectedRoute permission="medicine.buying_price.edit">
            <MedicineBuyingPrice />
          </ProtectedRoute>
        }
      />
      <Route path="/services" element={<ProtectedRoute permission="catalog.view"><MedicinesList /></ProtectedRoute>} />
      <Route path="/services/new" element={<ProtectedRoute permission="catalog.view"><AddNewMedicine /></ProtectedRoute>} />
      <Route path="/labs" element={<ProtectedRoute permission="catalog.view"><MedicinesList /></ProtectedRoute>} />
      <Route path="/labs/new" element={<ProtectedRoute permission="catalog.view"><AddNewMedicine /></ProtectedRoute>} />

      <Route path="/billing" element={<ProtectedRoute permission="billing.view"><BillingList /></ProtectedRoute>} />
      <Route path="/billing/new" element={<ProtectedRoute permission="billing.edit"><AddBilling /></ProtectedRoute>} />
      <Route path="/billing/view/:id" element={<ProtectedRoute permission="billing.view"><PrintBill /></ProtectedRoute>} />
      <Route path="/billing/print/:id" element={<ProtectedRoute permission="billing.view"><PrintBill /></ProtectedRoute>} />

      <Route
        path="/employees/new"
        element={
          <ProtectedRoute permission="employees.edit">
            <AddEmployee />
          </ProtectedRoute>
        }
      />

      <Route
        path="/employees"
        element={
          <ProtectedRoute permission="employees.view">
            <EmployeesList />
          </ProtectedRoute>
        }
      />

      <Route
        path="/employees/attendance"
        element={
          <ProtectedRoute permission="employees.edit">
            <EmployeeAttendance />
          </ProtectedRoute>
        }
      />

      <Route
        path="/employees/shifts"
        element={
          <ProtectedRoute permission="employees.edit">
            <EmployeeShifts />
          </ProtectedRoute>
        }
      />

      <Route
        path="/employees/leaves"
        element={
          <ProtectedRoute permission="employees.edit">
            <EmployeeLeaves />
          </ProtectedRoute>
        }
      />

      <Route
        path="/contacts/new"
        element={
          <ProtectedRoute permission="contacts.edit">
            <AddEditContact />
          </ProtectedRoute>
        }
      />

      <Route
        path="/contacts"
        element={
          <ProtectedRoute permission="contacts.view">
            <ContactList />
          </ProtectedRoute>
        }
      />

      <Route
        path="/reports/income"
        element={
          <ProtectedRoute permission="reports.income.view">
            <IncomeReport />
          </ProtectedRoute>
        }
      />

      <Route
        path="/reports/stock"
        element={
          <ProtectedRoute permission="reports.stock.view">
            <StockReport />
          </ProtectedRoute>
        }
      />

      <Route
        path="/configuration"
        element={
          <ProtectedRoute permission="configuration.view">
            <ClinicalSuggestionsConfig />
          </ProtectedRoute>
        }
      />
      <Route
        path="/configuration/minimum-stock"
        element={
          <ProtectedRoute permission="configuration.minimum_stock.view">
            <MedicineMinimumStockConfig />
          </ProtectedRoute>
        }
      />

      <Route path="*" element={<div className="p-8">Page not found</div>} />
    </Routes>
  )
}

export default AppRoutes
